import { NgModule } from '@angular/core';
import { SubscriptionDialogComponent } from './subscription-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from '../../../shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { MessageBoardSubscriptionService } from '../../../../services/message-board/message-board-subscription.service';


@NgModule({
    declarations: [
        SubscriptionDialogComponent,
    ],
    imports: [
        SharedModule,
        MatDialogModule,
        MatRadioModule,
    ],
    providers: [
        MessageBoardSubscriptionService
    ]
})
export class SubscriptionDialogModule
{
}
